import _ from 'underscore';
import { createSelector } from 'reselect';
import entitiesSelector from './entities_selector';
import meetingsSelector from './meetings_selector';
import teachersSelector from './teachers_selector';
import cohortsSelector from './cohorts_selector';
import meetingLayersSelctor from './meeting_layers_selector';

import Time from '../lib/time';

const formatDuration = duration => {
	let hours = duration.hours > 0 ? Math.floor(duration.hours) : null;
	let minutes = duration.minutes > 59 ? Math.floor((duration.hours % 1) * 60)  : duration.minutes;
	let str = '';
	
	if(hours && hours > 0) {
		if(hours === 1) {
			str += hours + ' hour ';
		}
		else {
			str += hours + ' hours ';
		}
	}
	
	if(minutes === 1) {
		str += minutes + ' minute';
	}
	else if(minutes > 1) {
		str += minutes + ' minutes';
	}

	return str;
};

const isScheduled = (scheduledMeeting, meeting) => {
	return meeting && meeting.name !== 'Available';
};

const isSimilarToInspectedMeeting = (scheduledMeeting, state) => {
	if(!state.entities) return false;

	// we currently only inspect one meeting at a time
	let inspectedMeeting = state.entities[_.first(state.inspected)];

	if(inspectedMeeting && inspectedMeeting !== scheduledMeeting) {
		if(scheduledMeeting.name === inspectedMeeting.name &&
			 scheduledMeeting.start_time === inspectedMeeting.start_time &&
			 scheduledMeeting.end_time === inspectedMeeting.end_time &&
			 scheduledMeeting.teacher_ids === inspectedMeeting.teacher_ids &&
			 scheduledMeeting.cohort_ids === inspectedMeeting.cohort_ids) {
			return true;
		}
	}
	return false;
};

let scheduledMeetingsSelector = entitiesSelector(
	state => state.scheduledMeetings,
	(scheduledMeeting, localState, { teachers, cohorts, meetings}) => {

		let duration = Time.duration(scheduledMeeting.start_time, scheduledMeeting.end_time);
		let meeting = scheduledMeeting.meeting_id ? meetings[scheduledMeeting.meeting_id] : null;

		return {
			name: scheduledMeeting.name ? scheduledMeeting.name : scheduledMeeting.meeting_id,
			scheduled: isScheduled(scheduledMeeting, meeting),
			duration: duration.minutes,
			associated_to_inspected: isSimilarToInspectedMeeting(scheduledMeeting, localState),
			durationString: formatDuration(duration),
			start_time_minutes: Time.parse(scheduledMeeting.start_time).totalMinutes,
			end_time_minutes: Time.parse(scheduledMeeting.end_time).totalMinutes,
			classNames: [
				scheduledMeeting.unavailable ? 'abl-unavailable' : null
			].concat(scheduledMeeting.classNames || []),

			// TODO: Need a better way to get associations
			teachers: _.compact(scheduledMeeting.teacher_ids.map(id => teachers[id])),
			cohorts: _.compact(scheduledMeeting.cohort_ids.map(id => cohorts[id])),
			meeting: meeting
		};
	},

	createSelector(
		state => teachersSelector.getAll(state),
		state => cohortsSelector.getAll(state),
		state => meetingsSelector.getAll(state),
		state => meetingLayersSelctor.getAll(state),
		(teachers, cohorts, meetings, layers) => {
			return {
				teachers: _.indexBy(teachers, 'id'),
				cohorts: _.indexBy(cohorts, 'id'),
				meetings: _.indexBy(meetings, 'id'),
				layers: layers
			}
		}
	)
);

const isActive = (meeting, filterGroups) => {
	return filterGroups.length > 0 &&
		_.all(filterGroups, filterGroup => {
			if(typeof filterGroup === 'function') {
				filterGroup = { filters: [filterGroup] };
			}
			let join = filterGroup.join === 'any' ? 'any' : 'all';
			return _[join](filterGroup.filters, filter => filter(meeting));
		});
}

const getActive = (state, filterGroups) => {
	return scheduledMeetingsSelector.filter(state, meeting => {
		return isActive(meeting, filterGroups);
	});
};


scheduledMeetingsSelector.getActive = getActive;

export default scheduledMeetingsSelector;


/** WEBPACK FOOTER **
 ** ./src/js/selectors/scheduled_meetings_selector.js
 **/